import React, { memo } from 'react'
import classNames from 'classnames'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import Sponsoring from './Sponsoring'

export default memo(({
	classes, gameImage, isMobileRes,	DareDetails,
	DareDetailIconSet, DareDetailButtonSet, sponsor,
	campaignId,
}) => (
	<div className={classNames('flex layout-row', classes.dareDetailsWrapper)}>
		<div className={classes.imageWrapper}>
			<img alt="Game" src={addHttpsProtocol(gameImage)} className={classes.image} />
		</div>
		<div className={classNames(classes.dareDetailsContent, 'flex layout-column layout-align-space-between')}>
			<div className="flex layout-row layout-align-space-between">
				<div className={classNames(classes.dareDetailsDataColumn, 'flex layout-column layout-align-start')}>
					<DareDetails />
				</div>
				{!isMobileRes && <DareDetailIconSet />}
				{!isMobileRes	&& sponsor
				&& <Sponsoring sponsor={sponsor} classes={classes} isMobileRes={isMobileRes} campaignId={campaignId} />
				}
			</div>
			<div className={classes.actionButtonsContainer}>
				<div className={classNames(classes.actionButtonSet, 'flex layout-row layout-align-space-between')}>
					<DareDetailButtonSet />
				</div>
			</div>
		</div>
	</div>
))
